import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { exchangeAuthorizationCode, redirectToLogin } from './sessionTokens'
import { FullScreenLoader } from '@/platform/ui/FullScreenLoader'

export function AuthCallbackPage() {
  const [params] = useSearchParams()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const code = params.get('code')
    if (!code) { setError('Thiếu mã xác thực.'); return }
    void exchangeAuthorizationCode(code).then(() => {
      const returnTo = params.get('returnTo')
      window.location.replace(returnTo?.startsWith('/') ? returnTo : '/')
    }).catch((cause) => setError(cause instanceof Error ? cause.message : 'Không thể xác thực.'))
  }, [params])

  if (!error) return <FullScreenLoader />
  return <div className="screen-center"><div className="card"><h1>Xác thực chưa hoàn tất</h1><p>{error}</p><button className="button-primary" onClick={() => redirectToLogin()}>Thử lại</button></div></div>
}
